export class InvoiceListModel {
    id: string;
    invoiceNumber: string;
    date: any;
    patientREF: string;
    patientId: string;
    invoiceTotal: number;
    amountOpen: number;
    balance: number;
    withholdTax: number;
    regNo: number;
    security: number;
    active: boolean;
    isBadDebt: boolean;
}

export enum SearchType {
  Individual = 0,
  Organization = 1,
  WithholdingTax = 2
}

export class CentreGroup {
  constructor(
      public id: string,
      public name: string,
      public isGroup?: boolean
  ) { }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/payment/invoice.model.ts